import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_Sepa = _resolveComponent("Sepa")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialog) = $event)),
    minWidth: _ctx.step === 'sepa' ? '1200px' : '800px',
    title: _ctx.title,
    "valid-title": _ctx.step === 'dates' ? 'Suivant' : 'Valider',
    "valid-disabled": _ctx.validDisabled,
    validLoading: _ctx.validLoading,
    previousDisplay: _ctx.step === 'sepa',
    onValid: _ctx.nextStep,
    onPrevious: _ctx.previousStep,
    actions: _ctx.actions
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_window, {
        modelValue: _ctx.step,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: 'dates' }, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, {
                modelValue: _ctx.formIsValid,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formIsValid) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_date_picker_filled, {
                            modelValue: _ctx.startDate,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event)),
                            "hide-details": "",
                            textFieldReadOnly: false
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_date_picker_filled, {
                            modelValue: _ctx.endDate,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.endDate) = $event)),
                            "hide-details": "",
                            class: "pl-2",
                            textFieldReadOnly: false
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 'sepa' }, {
            default: _withCtx(() => [
              (_ctx.step === 'sepa')
                ? (_openBlock(), _createBlock(_component_Sepa, {
                    key: 0,
                    companyId: _ctx.companyId,
                    filteredThirdPartyCompanies: _ctx.filteredThirdPartyCompanies,
                    startDate: _ctx.startDate,
                    endDate: _ctx.endDate,
                    accountableAccount: _ctx.accountableAccount,
                    actions: _ctx.sepaActions,
                    onOnUpdated: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onActionDone()))
                  }, null, 8, ["companyId", "filteredThirdPartyCompanies", "startDate", "endDate", "accountableAccount", "actions"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue", "minWidth", "title", "valid-title", "valid-disabled", "validLoading", "previousDisplay", "onValid", "onPrevious", "actions"]))
}